import React, { useState } from "react";
import styles from "./styles.module.css";
import { format, addDays, getDay, nextMonday } from "date-fns";
import { ru } from "date-fns/locale";

const Bootcamp = ({
  title,
  logoForProfession,
  mainDescProfession,
  mainCoursesInBundle,
  startDay,
}) => {
  function getValidDay(date) {
    const number = getDay(date);
    if (number === 0) {
      return 6;
    }

    return number;
  }

  function formatDisplay(date) {
    return format(date, "d MMMM", { locale: ru });
  }

  function getStartCourseDate(currentDate, courseStartDay) {
    let result = currentDate;
    if (getValidDay(currentDate) > courseStartDay + 1) {
      result = nextMonday(result);
      return addDays(result, courseStartDay);
    }

    return addDays(result, courseStartDay - getValidDay(currentDate) + 1);
  }

  return (
    <div className={styles.courseCard}>
      <div className={styles.content}>
        <div className={styles.courseLogo}>
          <img src={logoForProfession.file.url} alt={"NFT буткемпа"} />
        </div>

        <div className={styles.textContent}>
          <div className={styles.courseName}>
            <span>{title}</span>
          </div>
          <div className={styles.courseDesc}>{mainDescProfession}</div>
          <div className={styles.coursesInBundle}>
            {mainCoursesInBundle.map((courseInBundle, i) => {
              if (mainCoursesInBundle.length - 1 !== i) {
                return (
                  <div key={i} className={styles.courseItemInBundle}>
                    <span>{courseInBundle}</span>
                    <span className={styles.separator}>|</span>
                  </div>
                );
              }
              return (
                <div key={i} className={styles.courseItemInBundle}>
                  <span>{courseInBundle}</span>
                </div>
              );
            })}
          </div>
          <div className={styles.courseType}>
            Старт{" "}
            <span className={styles.amountOfCoursesInBundle}>
              {formatDisplay(getStartCourseDate(new Date(), startDay))}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bootcamp;
